var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircleOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7062 6.94801L9.66536 12.9888L6.37453 9.70717L5.08203 10.9997L9.66536 15.583L16.9987 8.24967L15.7062 6.94801ZM11.4987 1.83301C6.4387 1.83301 2.33203 5.93967 2.33203 10.9997C2.33203 16.0597 6.4387 20.1663 11.4987 20.1663C16.5587 20.1663 20.6654 16.0597 20.6654 10.9997C20.6654 5.93967 16.5587 1.83301 11.4987 1.83301ZM11.4987 18.333C7.44703 18.333 4.16536 15.0513 4.16536 10.9997C4.16536 6.94801 7.44703 3.66634 11.4987 3.66634C15.5504 3.66634 18.832 6.94801 18.832 10.9997C18.832 15.0513 15.5504 18.333 11.4987 18.333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleOutlined);
export default __webpack_public_path__ + "static/media/check-circle-outlined.89e5e15801f146eb9491a6812964152e.svg";
export { ForwardRef as ReactComponent };